module.exports = __webpack_public_path__ + "img/glasses.675dc0cb.svg";